import { render, staticRenderFns } from "./ObrigadoVidasPassadas.vue?vue&type=template&id=203f35cb"
import script from "./ObrigadoVidasPassadas.vue?vue&type=script&lang=js"
export * from "./ObrigadoVidasPassadas.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoVidasPassadas.vue?vue&type=style&index=0&id=203f35cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports